import HGLink from '../index'
import { LinkProps } from '../links.types'

export default function LinkInsights({
  children,
  slug,
  category,
  ...props
}: LinkProps & {
  slug?: string
  category?: string
}) {
  return (
    <HGLink
      href={getInsightsHref(slug)}
      aria-label={`go to insights ${category}`.toLocaleLowerCase()}
      {...props}
    >
      {children}
    </HGLink>
  )
}

export function getInsightsHref(slug?: string) {
  if (!slug) {
    return '/insights'
  }
  return `/insights/${slug}`
}
